import { createReducer, on, createFeature, provideState } from '@ngrx/store';
import { AuthTokenActions } from './auth-token.actions';
import { makeEnvironmentProviders } from '@angular/core';
import { provideEffects } from '@ngrx/effects';
import { AuthTokenEffects } from './auth-token.effects';

export const initialState: Readonly<string> = '';

export const authTokenFeature = createFeature({
  name: 'authToken',
  reducer: createReducer(
    initialState,
    on(AuthTokenActions.startSessionSuccess, (state, { token }) => {
      return token;
    })
  ),
});

export const { selectAuthTokenState } = authTokenFeature;

export function provideAuthTokenFeature() {
  return makeEnvironmentProviders([
    provideState(authTokenFeature),
    provideEffects(AuthTokenEffects),
  ]);
}
